/**
 * Preview feature constants.
 * Values are plain strings stored per-firm in the backend database (previewFeatures: [String!]!).
 * No backend schema change is needed to add a new entry — just add the constant here and set
 * the matching string value on the firm via the admin tooling.
 */
export const PreviewFeature = {
    /** New Workspace 2.0 feature */
    NEW_WORKSPACE_20: 'NEW_WORKSPACE_20',
    /** Level of Specification Automation feature */
    LOS_AUTOMATION: 'LOS_AUTOMATION',
    /** Product Type Automation feature */
    PT_AUTOMATION: 'PT_AUTOMATION',
    /** OM Workspace - enables new workspace toggle for Office Master workspaces */
    OM_WORKSPACE: 'OM_WORKSPACE',
    /** OM PT Link Automation - shows Product Type/Group link icons in OM workspace */
    OM_PT_LINK_AUTOMATION: 'OM_PT_LINK_AUTOMATION',

    /** API Subscription Management - enables the API Subscription section on account setup */
    API_SUBSCRIPTION_MANAGEMENT: 'API_SUBSCRIPTION_MANAGEMENT',
    /** AppHarmony Header - enables the Harmony (light) header to replace main App Header */
    APP_HARMONY_HEADER: 'APP_HARMONY_HEADER',
    /** Project Tasks - enables the kanban task board and task indicators in the workspace */
    PROJECT_TASKS: 'PROJECT_TASKS',
    /** Match Score Page - enables the Match Score nav item and page for BPM users */
    MATCH_SCORE_PAGE: 'MATCH_SCORE_PAGE',
} as const

/** Type for preview feature values */
export type PreviewFeature = typeof PreviewFeature[keyof typeof PreviewFeature]
